import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { Request } from '../../../httpClient/serverApi/requests/Request';

export interface IForcePasswordUpdateParams {
  siteUserIds?: string[];
}

export interface IForcePasswordUpdateResult extends IResult {
}

export class ForcePasswordUpdateOnSiteUsersRequest extends Request<IForcePasswordUpdateParams, IForcePasswordUpdateResult> {
  constructor(params: IForcePasswordUpdateParams) {
    super('forcePasswordUpdateOnSiteUsers', params);
  }
}
